import type { BorderRadiusTokens } from '../types';

export const borderRadius: BorderRadiusTokens = {
  borderRadiusNone: '0',
  borderRadiusSmall: '2px',
  borderRadiusMedium: '4px',
  borderRadiusLarge: '6px',
  borderRadiusXLarge: '8px',
  borderRadiusCircular: '10000px',
};
